export const EXPORT_CSV = 'export-csv';
export const EXPORT_EXCEL = 'export-excel';
export const EXPORT_PDF = 'export-pdf';
export const EXPORT_TEXT = 'export-text';
export const RUN_REPORT = 'run-report';
export const ACTIONS_MAP = {
  [EXPORT_CSV]: 'CSV',
  [EXPORT_EXCEL]: 'XLS',
  [EXPORT_PDF]: 'PDF',
  [EXPORT_TEXT]: 'TXT',
  [RUN_REPORT]: 'HTML',
};
